/*
 * Jira Ticket:
 * Created Date: Mon, 1st Jun 2020, 15:21:12 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const createRegionMutation = gql`
  mutation createRegion($name: String!, $countries: [ID!]!, $locales: [ID!]!) {
    data: createRegion(name: $name, countries: $countries, locales: $locales) {
      id
      name
      countries {
        id
      }
      locales {
        id
      }
    }
  }
`;
